var restorepasswordmanual = {
    restore: "CHANGE PASSWORD",
    eyebrowLabel: "Secure password update",
    text1: "Enter your new password",
    text2: "Create a strong password to keep your account secure.",
    panelTitle: "Set your new password",
    panelText: "Use at least 8 characters and make sure both fields match before saving the change.",
    login: "go Login",
    newpass: "New Password:",
    renewpass: "Repeat Password:",
    newpassPlaceholder: "Enter your new password",
    renewpassPlaceholder: "Confirm your new password",
    sendbtn: "Save",
    saving: "Saving...",
    error: "error: confirm password must be equal",
    msg: "Your password has been changed, go Login to get access again",
    loginbtn: "go Login",
    errorpage: "ERROR PAGE",
    errortext1: "This page has an error",
    errorgo: "please, Click here:",
    errorbtn: "Try again",
    requiredNewPassword: "New password is required.",
    requiredRepeatPassword: "Please confirm your new password.",
    passwordMinLength: "Your password must be at least 8 characters long.",
    passwordMismatch: "Passwords do not match.",
    genericError: "We could not update your password right now. Please try again later.",
    successTitle: "Password updated",
    successText: "Your password was changed successfully. You can now sign in again with your new password.",
    successHelp: "For security, please use your new password the next time you log in.",
    invalidLinkTitle: "We could not prepare the password change",
    invalidLinkText: "Something went wrong while loading the information needed to update your password.",
    invalidLinkHelp: "Please try again from your account or sign in again if necessary.",
    loadingTitle: "Preparing your password update",
    loadingText: "Please wait a moment while we validate your access."
}
module.exports = restorepasswordmanual
